$(function(){
  initFilter();

  $(window).resize(function(){
    if (isChange) {
      setFilter();
    }
  });
});

function initFilter() {
  setFilter();

  $('.searchBar .filter .options img').click(function(){
    var filter = $(this).parents('.filter');
    var lable = filter.find('.lable');
    var options = filter.find('.options');
    options.stop(true).slideUp();

    if (lable.hasClass('hasList')) {
      lable.removeClass('hasList');
    } else {
      lable.addClass('hasList');
    }
  });
}

function setFilter() {
  if (isSp || isiPad) {
    $('.searchBar .filter, .searchBar .option').unbind('hover');

    $('.searchBar .filter .lable').click(function(){
      if ($(this).hasClass('hasList')) {
        $(this).removeClass('hasList');
      } else {
        $(this).addClass('hasList');
      }

      $(this).next('.options').stop(true).slideToggle(function(){
        $(this).css('overflow', '');
      });

      $(this).parents('.filter').siblings().find('.options').hide();
      $(this).parents('.filter').siblings().find('.lable').removeClass('hasList');
      $('.searchBar').removeClass('onMore');
    });

    $('.searchBar .option p').click(function(){
      $(this).next('ul').stop(true).slideToggle();
      if (isiPad) $(this).parents('.option').siblings().find('ul').slideUp();
    });
  } else {
    $('.searchBar .filter .lable, .searchBar .option p').unbind('click');
    $('.searchBar .filter .lable').removeClass('hasList');
    $('.searchBar .options, .searchBar .options ul').hide();

    $('.searchBar .filter').hover(function(){
      $(this).find('.options').stop(true).slideToggle(function(){
        $(this).css('overflow', '');
      });
    });

    $('.searchBar .option').hover(function(){
      $(this).find('ul').stop(true).slideToggle();
    });
  }
}